jQuery(document).ready(function($) {
    gtag('event', 'conversion', {'send_to': 'AW-650714728/K1-HCJufhd4CEOi8pLYC'});

    let options = document.querySelectorAll('.content .radio-buttons-container .checkbox-label span');
    let button = document.querySelector('.nf__afterfields-container button');
    let bookCallHref = document.querySelector('.right .button-container .book-a-call');
    let bookCall = document.querySelector('.right .button-container button');

    let question1 = false;
    let question2 = false;
    let question3 = false;
    let question4 = false;

    for(let i = 0; i< options.length; i++) {
        options[i].addEventListener('click', () => {
            if(i < 4) {
                question1 = true;
            } else if(i > 3 && i < 8) {
                question2 = true;
            } else if(i > 7 && i < 12) {
                question3 = true;
            } else if(i > 11) {
                question4 = true;
            }
            if(question1 === true && question2 === true && question3 === true && question4 === true) {
                button.addEventListener('click', () => {
                    if (!(button.classList.contains('disabled'))) {
                        gtag('event', 'conversion', {'send_to': 'AW-650714728/VZtaCJS6qd4CEOi8pLYC'});
                    }
                })
            }
        })
    }

    function gtag_report_conversion(url) {
        var callback = function () {
            if (typeof (url) !== undefined) {
                window.location = url;
            }
        };
        gtag('event', 'conversion', {
            'send_to': 'AW-650714728/nDD3CIf9hd4CEOi8pLYC',
            'event_callback': callback
        });
        return false;
    }


    bookCall.addEventListener('click', () => {
        gtag_report_conversion(bookCallHref.getAttribute('href'));
    })
    var input = document.querySelector("#phone");
    window.intlTelInput(input, {
        // any initialisation options go here
    });
})